var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9291 18.8201C14.7391 18.8201 14.5491 18.7501 14.3991 18.6001C14.1091 18.3101 14.1091 17.8301 14.3991 17.5401L19.9391 12.0001L14.3991 6.46012C14.1091 6.17012 14.1091 5.69012 14.3991 5.40012C14.6891 5.11012 15.1691 5.11012 15.4591 5.40012L21.5291 11.4701C21.8191 11.7601 21.8191 12.2401 21.5291 12.5301L15.4591 18.6001C15.3091 18.7501 15.1191 18.8201 14.9291 18.8201Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.83 12.75H4C3.59 12.75 3.25 12.41 3.25 12C3.25 11.59 3.59 11.25 4 11.25H20.83C21.24 11.25 21.58 11.59 21.58 12C21.58 12.41 21.24 12.75 20.83 12.75Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon2);
export default __webpack_public_path__ + "static/media/rightArrowIcon (2).69bcbb5486bde3b465c67805b7bf8fb1.svg";
export { ForwardRef as ReactComponent };